import graphql__842547bd01d4f07cdb4b from "./__generated__/ContributionCommentsPanel_contribution.graphql.js";import { useCallback } from "react";
import { graphql, usePaginationFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import CommentButton from "../../Comments/CommentButton";
import CommentsList from "../../Comments/CommentsList";
import { withCommentForm } from "../../GeneralServices/CommentFormService";
import InfinitelyScrollableContainer from "../../Utils/InfinitelyScrollableContainer";
import { useFormatMessage } from "../../Intl/Context";
import { isUnauthorized } from "../../Utils/authorizations";
import Report from "../../Reports/Report";
import ContributionBookmarkButton from "./ContributionBookmarkButton";
import ReactableMeasures from "./ReactableMeasures";

const ContributionCommentsPanel = props => {
  const {
    data: contribution,
    loadNext,
    hasNext,
    isLoadingNext
  } = usePaginationFragment(ContributionCommentsPanel_contribution, props.contribution);

  const { showCommentForm } = props;
  const { comments, totalCommentsCount, authorizations } = contribution;
  const {
    commentsDisplayAuthorized,
    submitComment,
    votesDisplayAuthorized,
    votesSubmissionAuthorized
  } = authorizations;
  const { submitComment: submitCommentUnauthorizedMessage } =
    authorizations.unauthorizedMessages;

  const t = useFormatMessage();
  const loadMoreLabel = t(intlMessages.loadMore);

  const commentsNodes = comments.edges.map(edge => edge.node);

  const loadMore = useCallback(() => {
    if (!hasNext || isLoadingNext) return;

    loadNext(10);
  }, [hasNext, loadNext, isLoadingNext]);

  // Do not show the comments panel if comments are not enabled
  if (isUnauthorized(commentsDisplayAuthorized)) return null;

  const hasMoreCommentsToLoad = comments.length && hasNext;
  const className = classNames(["box", "comments", props.className]);

  // Display measures if votes are displayed but not submittable, or if we can't submit
  // comments.
  const displayMeasures =
    (!isUnauthorized(votesDisplayAuthorized) &&
      isUnauthorized(votesSubmissionAuthorized)) ||
    isUnauthorized(submitComment);

  return (
    <div className={className}>
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center flex-1">
          {displayMeasures && (
            <ReactableMeasures
              reactable={contribution}
              hideVotes={!isUnauthorized(votesSubmissionAuthorized)}
              hideComments={!isUnauthorized(submitComment)}
              className="margin-right-sm"
            />
          )}

          {!isUnauthorized(submitComment) && (
            <CommentButton
              count={totalCommentsCount}
              onClick={showCommentForm}
              disabledMessage={submitCommentUnauthorizedMessage}
            />
          )}
        </div>

        <div className="d-flex">
          <ContributionBookmarkButton
            contribution={props.contribution}
            displayLabel={false}
            ignoreDefaultClassName={true}
            className="btn btn-unstyled padding-xxs margin-right-xxs"
          />

          <Report reportable={props.contribution} />
        </div>
      </div>

      {totalCommentsCount > 0 && (
        <InfinitelyScrollableContainer
          className="comment-list-scrollable-container margin-top-sm"
          onBottomReached={loadMore}
        >
          <CommentsList comments={commentsNodes} />
        </InfinitelyScrollableContainer>
      )}

      {hasMoreCommentsToLoad && (
        <button
          className="btn btn-primary comments-load-more"
          onClick={loadMore}
          disabled={isLoadingNext}
          data-loading={isLoadingNext}
        >
          {loadMoreLabel}
        </button>
      )}
    </div>
  );
};

const ContributionCommentsPanel_contribution = graphql__842547bd01d4f07cdb4b;

export default withCommentForm(ContributionCommentsPanel);

const intlMessages = defineMessages({
  loadMore: {
    id: "comments.list.loadMore",
    defaultMessage: "Voir plus de commentaires ..."
  }
});
